/**
 * Browser-facing API path prefixes (single origin).
 * Vite dev server / nginx rewrites these to each service’s `/api/v1.0/...`.
 */
export const API_AUTH_PREFIX = "/api/auth";
/** People service admin API — proxied to `/api/v1.0/admin` in dev. */
export const API_ADMIN_PREFIX = "/api/admin";
/**
 * People service non-admin API. The People proxy mounts at site root (matches
 * the production nginx `location /api/people/`), so the browser path must
 * include the full Django URL — `/api/people/api/v1.0/<resource>/`. See
 * `frontend-shell/src/api/client.ts::peopleCoreApi` for the existing pattern.
 */
export const API_PEOPLE_PREFIX = "/api/people/api/v1.0";
export const API_EMAIL_PREFIX = "/api/email";
export const API_DRIVE_PREFIX = "/api/drive";
export const API_DOCS_PREFIX = "/api/docs";
export const API_VIDEO_PREFIX = "/api/video";
export const API_CALENDAR_PREFIX = "/api/calendar";
export const API_CHAT_PREFIX = "/api/chat";
export const API_AUDIT_PREFIX = "/api/audit";
export const API_OFFICE_PREFIX = "/api/office";

export function peopleAuthPath(relative: string): string {
  const p = relative.replace(/^\/+/, "").replace(/\/+$/, "");
  return `${API_AUTH_PREFIX}/${p}/`;
}
